/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';

const Card = ({ products, setMod }) => (
  <div className="prod_card_list r-container">
    {products
      ? products.map((prod) => (
          <div
            className={prod.description !== '' ? 'prod_card prod_card_wd aos' : 'prod_card aos'}
            data-delay="0.2"
            onClick={() => {
              if (prod.description !== '') {
                setMod(prod);
              }
            }}
          >
            <img src={`/public/uploads/${prod.product_img}`} alt="" />
            <span>{prod.pname}</span>
          </div>
        ))
      : ''}
  </div>
);
export default Card;
